/* eslint-disable @typescript-eslint/no-misused-promises */
import Image from 'next/image'
import { HomeComponentType } from '@components/HomePage/utils/HomeComponentType'
import { ProductCardButton } from '@components/Home/ProductCardButton/ProductCardButton'
import { Domain } from '@enums/Domain'
import { IBannerProps } from '@interfaces/landingWidget'
import Link from 'next/link'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { domainConfig } from '@configs/domain.config'
import {
  carDropLogo,
  carDropMock,
  desktopCarDropThumbnailUrl,
  desktopCarDropVideoUrl,
  mobileCarDropThumbnailUrl,
  mobileCarDropVideoUrl,
} from 'homepageMock'
import styles from './productbanner.module.scss'

export interface IProductBannerProps {
  data: IBannerProps
}

const AckoDriveProductBanner = ({ data }: IProductBannerProps) => {
  const mockValues = carDropMock
  const handleBannerClick = async () =>
    await trackEvent(domainConfig[Domain.ACKO].events.homePage, { type: mockValues?.trackEventType })
  return (
    <div id={HomeComponentType.ProductBanner}>
      <div className={styles.ackoDriveProductContainer}>
        <Link
          className={styles.banner}
          href={mockValues?.buttonLink}
          rel="noopener noreferrer"
          onClick={handleBannerClick}>
          <video
            className={styles.bgVideoDesktop}
            poster={desktopCarDropThumbnailUrl}
            loop
            autoPlay
            muted
            playsInline
            disableRemotePlayback
            disablePictureInPicture>
            <source src={desktopCarDropVideoUrl} />
          </video>
          <video
            className={styles.bgVideoMobile}
            poster={mobileCarDropThumbnailUrl}
            loop
            autoPlay
            muted
            playsInline
            disableRemotePlayback
            disablePictureInPicture>
            <source src={mobileCarDropVideoUrl} />
          </video>
          <div className={styles.bannerContent}>
            <div className={styles.bannerTexts}>
              <Image src={carDropLogo} alt="CarDrop logo" className={styles.bannerLogo} width={130} height={36} />
              <div className={styles.bannerHeading}>{mockValues?.heading}</div>
              <div className={styles.bannerSubHeading}>{mockValues?.subHeading}</div>
            </div>
            <div className={styles.bannerButton}>{mockValues?.buttonText}</div>
          </div>
        </Link>
        <span className={styles.ackoDriveProductHeading}>{data?.heading}</span>
        <div className={styles.ackoDriveProductSubHeading}>
          <span className={styles.subHeadingText}>{data?.subHeading}&nbsp;</span>
          <Image src={data?.logoSrc} width={90} height={28} alt="product logo" className={styles.logo} />
        </div>
        <div className={styles.ackoDriveProductWrapper}>
          {data?.productCards?.data?.map(productItem => (
            <ProductCardButton
              key={productItem?.id}
              product={productItem?.attributes}
              imageSize={136}
              domain={Domain.ACKODRIVE}
            />
          ))}
        </div>
        <div className={styles.disclaimer}>{data?.productsDisclaimer}</div>
      </div>
    </div>
  )
}

export default AckoDriveProductBanner
